import React from "react";

export const consultationConfig = [
  {
    auth: ["user"],
    routes: [
      {
        exact: false,
        path: "/appointments/video-consultation",
        component: React.lazy(() => import("./VideoConsultation2")),
        unmountOnExit: true,
      },
      {
        exact: false,
        path: "/external_video_consultation/join",
        component: React.lazy(
          () =>
            import(
              ".././../../shared/components/Video/multiVideoMiddlewareComponent"
            )
        ),
        unmountOnExit: false,
      },
    ],
  },
];
